import React from 'react';

export const AlertMsg = ({ alert }) => {
  if (alert !== null && alert.type && alert.msg) {
    return <div className={`alert alert-${alert.type}`}>{alert.msg}</div>;
  }
  return null;
};
